const imageUrlBuilder = require('@sanity/image-url');

// Initialize the imageUrlBuilder with your Sanity configuration
const builder = imageUrlBuilder({
  projectId: window?.MoMA?.appInfo?.sanityProjectID || "",
  dataset: window?.MoMA?.appInfo?.sanityDataset || ""
});

/**
 * Helper function to build image URLs with transformations
 * @param {Object} image - Sanity image object with asset, crop, and hotspot
 * @param {Object} options - Image transformation options
 * @param {number} [options.width] - Image width
 * @param {number} [options.height] - Image height
 * @returns {string} The transformed image URL
 */
const getImageUrl = (image, options = {}) => {
  if (!image?.asset?._ref) {
    console.error('Invalid image object provided');
    return '';
  }

  // Create a source object that includes asset, crop, and hotspot
  const source = {
    asset: {
      _ref: image.asset._ref,
      _type: 'reference'
    }
  };

  // Add crop if present
  if (image.crop) {
    source.crop = image.crop;
  }

  // Add hotspot if present
  if (image.hotspot) {
    source.hotspot = image.hotspot;
  }

  // Initialize URL builder with the full source object
  let urlBuilder = builder.image(source);
  
  // Apply width if specified
  if (options.width) {
    urlBuilder = urlBuilder.width(options.width);
  }
  
  // Apply height if specified
  if (options.height) {
    urlBuilder = urlBuilder.height(options.height);
  }

  // Set fit mode to maintain aspect ratio
  urlBuilder = urlBuilder.fit('crop');

  return urlBuilder.url();
};

module.exports = {
  getImageUrl
}; 